import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const SubscriptionView = ({ currentItem, handleView }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[850px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("VIEW_SUBSCRIPTION")}</h3>
                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none" onClick={() => handleView(false)}>
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-3">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Subscription ID:</strong>
                      <h6>{currentItem._id || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Subscription name:</strong>
                      <h6>{currentItem.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Amount:</strong>
                      <h6>${currentItem.amount || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Duration (in days):</strong>
                      <h6>{currentItem.duration || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Number of employees:</strong>
                      <h6>{currentItem.noOfEmployee || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Number of HR:</strong>
                      <h6>{currentItem.noOfHR || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Number of accountant:</strong>
                      <h6>{currentItem.noOfAccountant || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Created date:</strong>
                      <h6>{dayjs(currentItem?.createdAt).format("MM-DD-YYYY hh:mm A")} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Updated date:</strong>
                      <h6>{dayjs(currentItem?.updatedAt).format("MM-DD-YYYY hh:mm A")} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Purchased count:</strong>
                      <h6>{currentItem?.purchasedCount} </h6>
                    </div>
                  </div>
                </div>
                <div className="grid">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Description:</strong>
                      <h6 className="max-h-[200px] overflow-auto ">
                        {" "}
                        {currentItem &&
                          currentItem?.description?.map((item, i) => {
                            return (
                              <ul key={i}>
                                <li className="flex justify-between bg-gray-100 text-gray-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500 mt-2">{item}</li>
                              </ul>
                            );
                          })}
                      </h6>
                      {/* <ul>
                        <li>{currentItem.description.join(', ') || ''}</li>
                      </ul> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => handleView()}>
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default SubscriptionView;
